import { useState } from "react";
import Modal from "../../../components/Modal";

const ApprovalRequestPopup = ({ isOpen, onClose, onSubmit }) => {
  const [message, setMessage] = useState("");

  const handleSubmit = () => {
    if (!message.trim()) {
      return;
    }
    onSubmit(message);
    setMessage("");
    onClose();
  };

  const handleCancel = () => {
    setMessage("");
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCancel}
      title="Đề xuất duyệt hồ sơ"
      maxWidth="500px"
      primaryButtonText="Gửi đề xuất"
      primaryButtonOnClick={handleSubmit}
      cancelButtonText="Hủy"
    >
      <div className="px-6 py-4">
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Nhập nội dung đề xuất duyệt:
        </label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none"
          rows={4}
          placeholder="Nhập nội dung..."
          autoFocus
        />
      </div>
    </Modal>
  );
};

export default ApprovalRequestPopup;
